export enum envNames {
	PROD = 'PROD',
	STAG = 'STAG',
	DEV = 'DEV',
}
